<template>
  <div class="content">
    <!--头部-->
    <div style="overflow: hidden">
      <base-header></base-header>
    </div>
    <div>
      <!--左侧栏-->
      <left-menu></left-menu>
      <div class="rightContent" :height="height">

        <router-view/>
        <msg></msg>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import baseHeader from '@/components/common/header/header'
  import leftMenu from '@/components/common/leftMenu/leftMenu'
  import msg from '@/components/common/message/systemMessage';
  export default {
    name: 'Homepage',
    components: {
      leftMenu,
      baseHeader,
      msg
    },
    data () {
      return {
        height: ''
      }
    },
    mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
    methods: {
 //     _getRightW() {
 //       let width = document.getElementById('app').clientWidth
//        let right = document.getElementsByClassName('rightContent')
//        right[0].style.width = width - 180 + 'px'
//      }
    },
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .content
    min-width: 100vw
    height: 100vh
    overflow: hidden
  .rightContent
    position: relative
    float: left
    width: calc(100vw - 180px)
    min-width: 1020px
</style>



// WEBPACK FOOTER //
// homePage.vue?5fdfab50